import React from 'react';
import styles from './AnnouncementBar.module.css';
const announcementItems = [
  "Breaking News: Important announcement",
  "Latest updates from around the world",
  "Technology news: New innovations",
  "Sports highlights of the day"
];
const AnnouncementBar = (props) => {
  console.log(props);
  return (
    <div className={styles.announcementContainer}>
      <div className={styles.announcementContent}>
        {props.announcementItems.map((item, index) => (
          <div key={index} className={styles.itemContainer}>
            <span className={styles.announcementItem}>{item}</span>
            {index < props.announcementItems.length - 1 && <span className={styles.dot}>•</span>}
          </div>
        ))}
        {/* Duplicate items for seamless loop */}
        {props.announcementItems.map((item, index) => (
          <div key={`clone-${index}`} className={styles.itemContainer}>
            <span className={styles.announcementItem}>{item}</span>
            {index < props.announcementItems.length - 1 && <span className={styles.dot}>•</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnnouncementBar; 